<form [formGroup]="districtForm">
	<mat-form-field appearance="fill">
		<mat-label>
		<!--	<mat-icon *ngIf="isLoading">
				<mat-spinner diameter="13"> </mat-spinner>
			</mat-icon>-->
			School District(s) {{(this.selectedDistrict.length > 0)? ':' + this.selectedDistrict.length: ''}}
		</mat-label>
		<mat-select (click)="fnOpenDialog($event)" formControlName="districtSelect">
		</mat-select>
		<mat-icon *ngIf="isLoading" class="loading-shadeMini">		
			<mat-spinner diameter="20"> </mat-spinner>
		</mat-icon> 
	</mat-form-field>
</form>